// extracted by mini-css-extract-plugin
export default {"container__viewer":"Viewer_container__viewer__RvUsh","videoContainer":"Viewer_videoContainer__5+z3F","container__videoControls":"Viewer_container__videoControls__63tOT"};